import React, { useState, useContext } from 'react'
import './style.scss';
import Requests from "../../utils/Requests/Index"
import Icon from 'react-icons-kit'
import { Images } from '../../utils/Images'
import { NavLink, Link } from 'react-router-dom'
import { DropdownButton, Dropdown } from 'react-bootstrap'
import { thumbsUp, search, users, messageSquare, chevronUp, bell } from 'react-icons-kit/feather'
import { person } from 'react-icons-kit/oct'
import { envelopeO } from 'react-icons-kit/fa'
import { UserContext } from '../../utils/context/userContext';
import ChatDialog from '../ChatDialog/Index'
import Chatbar from '../Chatbar/Index'
import MessageContainer from '../MessageContainer/Index'
import { useSelector, useDispatch } from 'react-redux';
import { seenProfileViewed } from '../../utils/Redux/Slice/NotificationSlice'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { 
  Search, 
  Bell, 
  LayoutDashboard, 
  User, 
  Image as ImageIcon, 
  Users, 
  Phone, 
  Package, 
  CreditCard, 
  ChevronRight, 
  ChevronLeft,
  MoreVertical,
  MessageSquare,
  Link as LinkIcon,
  Mail,
  Eye,
  Smartphone,
  Calendar,
  CheckCircle2
} from 'lucide-react';
// toast.configure({ autoClose: 2000 })

const Index = () => {
    const [header] = useState({ headers: { Authorization: "Bearer " + localStorage.getItem('token') } })
    const { user } = useContext(UserContext)
    const [dialog, setDialog] = useState({ view: false, state: null })
    const messageBoxState = useSelector((state) => state.messageBoxState.view)
    const connectedList = useSelector((state) => state.membersList.connected)
    const matchList = useSelector((state) => state.membersList.match)
    const previousList = useSelector((state) => state.membersList.previous)
    const arrivalMsgCount = useSelector((state) => state.arrivalMessage.count)
    const connectionNotificationCount = useSelector((state) => state.notification.count)
    const notifications = useSelector((state) => state.notification)
    const [view, setView] = useState(false)
    const dispatch = useDispatch()

    const doLogout = async () => {
        try {
            await Requests.Auth.Logout(header);
            localStorage.clear()
            window.location.reload()
        } catch (err) {
            if (err) console.log(err);
        }
    }
    const handleNotificationView = e => {
        e.preventDefault()
        setView(!view)
    }
    const removeViewPerson = async() =>{
        try {
            const res = await Requests.Auth.DeleteProfileViewNotification(header);
            if(res.status){
                toast.success(res.message)
                dispatch(seenProfileViewed())
            }
            else{
                toast.errpr(res.message)
            }
        } catch (err) {
            if (err) console.log(err);
        }
    }

    // console.log(user.profilePicture);
    

    if (!user) return 'loading'
    return (
        <div>
            <header className="top-header">
            <div className="search-bar">
                <Search size={18} className="search-icon" />
                <input type="text" placeholder="Search ( love connection )" />
            </div>
            <div className="header-actions">
                {user? 
                    <div className="d-block">
                        {/* <ul>
                            <li> */}
                                <div className='alert'>
                                    <Icon icon={bell} size={20} onClick={handleNotificationView} />
                                    {connectionNotificationCount > 0 ? <spna className='count'>{connectionNotificationCount}</spna> : null}
                                </div>
                            {/* </li> */}
                            {/* <li>
                                <DropdownButton
                                    title={<img src={user.gender === "male" ? Images.Avatar : Images.FemaleAvatar} className="img-fluid rounded-circle" alt="..." />}>
                                    <Dropdown.Item as={Link} to="/my-dashbord/profile">Profile</Dropdown.Item>
                                    <Dropdown.Item onClick={doLogout}>Logout</Dropdown.Item>
                                </DropdownButton>
                            </li> */}
                        {/* </ul> */}
                    </div>
                : null}
                {/* <img
                    src={
                        user?.profilePicture?.clearImage
                        || (user?.gender === "male" ? Images.Avatar : Images.FemaleAvatar)
                    }
                    onError={(e) => {
                        e.target.src = Images.Avatar;
                    }}
                    className="top-avatar img-fluid rounded-circle"
                    alt="avatar"
                    /> */}
                {/* <img 
                src={user?.profilePicture ? user?.profilePicture?.clearImage : (user.gender === "male" ? Images.Avatar :  Images.FemaleAvatar)}
                className=" top-avatar img-fluid rounded-circle" alt="..." /> */}

                {/* <img src="https://csspicker.dev/api/image/?q=woman+face&image_type=photo" alt="User" className="top-avatar" /> */}
            </div>
            </header>
            <div className="break"></div>

            <div className="d-lg-none menu-bar">
                {/* <NavLink activeClassName="isActive" to="/timeline"><span><Icon icon={messageSquare} size={25} /><p>timeline</p></span></NavLink> */}
                <NavLink className={({ isActive }) => isActive ? "isActive" : undefined} to="/connection"><span><Icon icon={users} size={25} /><p>
                    connections {(notifications.incomingProposal + notifications.acceptedProposal) > 0 ? <span className='notificationCount'>{notifications.incomingProposal + notifications.acceptedProposal}</span> : null} </p></span></NavLink>
                <NavLink className={({ isActive }) => isActive ? "isActive" : undefined} to="/matches"><span><Icon icon={thumbsUp} size={25} /><p>matches</p></span></NavLink>
                <NavLink className={({ isActive }) => isActive ? "isActive" : undefined} to="/search"><span><Icon icon={search} size={25} /><p>search</p></span></NavLink>
                <NavLink className={({ isActive }) => isActive ? "isActive" : undefined} to="/"><span><Icon icon={person} size={25} /><p>mybiyesadi</p></span></NavLink>
                <NavLink className={({ isActive }) => isActive ? "isActive" : undefined} to="/messanger"><span><Icon icon={messageSquare} size={25} /><p>
                    chat {arrivalMsgCount > 0 ? <span className='notificationCount'>{arrivalMsgCount}</span> : null}</p></span></NavLink>
            </div>
        </div>
    );
};

export default Index;